import {_utils} from "../../../utils/_utils.js";
import {_libs} from "../../../utils/_libs.js";

export const evolution = () => {
    return new Promise((resolve) => {
        _utils.initSection('.evolution', (section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const sliderEl = section.querySelector('[data-evolution-swiper]');
    if (!sliderEl) return;

    // milestones = real slides (the leading spacer is excluded)
    const milestones = [...sliderEl.querySelectorAll('.evolution__slide:not(.evolution__slide--spacer)')];
    const total = milestones.length;
    if (!total) return;

    const prevEl = section.querySelector('[data-evolution-prev]');
    const nextEl = section.querySelector('[data-evolution-next]');
    const currentEl = section.querySelector('[data-evolution-current]');
    const totalEl = section.querySelector('[data-evolution-total]');
    if (totalEl) totalEl.textContent = total;

    // active (highlighted) milestone, tracked independently of Swiper's scroll
    let active = 0;
    const isDesktop = () => window.matchMedia('(min-width: 1025px)').matches;

    const swiper = _libs._swiper(sliderEl, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        speed: 500,
        watchOverflow: false,   // stay interactive even when all slides fit
        allowTouchMove: false,  // no cursor/touch dragging — navigate via pagination only
        keyboard: {enabled: true},
        // autoHeight: true,
    });

    /* ---------- Autoplay (10s, no loop) ---------- */
    const AUTOPLAY = 10000;
    let timer = null;
    const stopAutoplay = () => {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    };
    const startAutoplay = () => {
        stopAutoplay();
        if (total <= 1) return;
        timer = setInterval(() => {
            if (active >= total - 1) { // reached the end — stop (no loop)
                stopAutoplay();
                return;
            }
            go(1);
        }, AUTOPLAY);
    };

    const render = () => {
        milestones.forEach((s, i) => s.classList.toggle('is-active', i === active));
        if (currentEl) currentEl.textContent = active + 1;
        if (prevEl) prevEl.classList.toggle('swiper-button-disabled', active <= 0);
        if (nextEl) nextEl.classList.toggle('swiper-button-disabled', active >= total - 1);
        // milestone[active] is Swiper slide index active+1 (spacer is 0).
        // Desktop: keep it at the 2nd column (slide before it at the start).
        // Mobile: keep the active itself at the start.
        swiper.slideTo(isDesktop() ? active : active + 1);
    };

    const go = (dir) => {
        const next = Math.min(total - 1, Math.max(0, active + dir));
        if (next === active) return;
        active = next;
        render();
    };

    // manual navigation also restarts the autoplay countdown
    const goManual = (target) => {
        target();
        // startAutoplay();
    };

    if (prevEl) prevEl.addEventListener('click', () => goManual(() => go(-1)));
    if (nextEl) nextEl.addEventListener('click', () => goManual(() => go(1)));

    milestones.forEach((slide, i) => {
        slide.addEventListener('click', () => {
            if (i === active) return;
            goManual(() => { active = i; render(); });
        });
    });

    // re-align on breakpoint change
    window.addEventListener('resize', () => render());

    render();
    // startAutoplay();
};
